import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const [mode, setMode] = useState('password');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [otpStep, setOtpStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const go = (user) => navigate(user.role === 'admin' ? '/admin' : '/colleague');

  const handlePasswordLogin = async () => {
    if (!phone || !password) return setError('شماره و رمز را وارد کنید');
    setLoading(true); setError('');
    try {
      const res = await api.post('/api/auth/login', { phone, password });
      login(res.data.token, res.data.user); go(res.data.user);
    } catch (err) { setError(err.response?.data?.error || 'خطا در ورود'); }
    finally { setLoading(false); }
  };

  const requestOTP = async () => {
    if (!phone) return setError('شماره موبایل را وارد کنید');
    setLoading(true); setError('');
    try {
      await api.post('/api/auth/request-otp', { phone });
      setOtpStep(2);
    } catch (err) { setError(err.response?.data?.error || 'خطا در ارسال کد'); }
    finally { setLoading(false); }
  };

  const verifyOTP = async () => {
    if (!code || code.length !== 6) return setError('کد 6 رقمی وارد کنید');
    setLoading(true); setError('');
    try {
      const res = await api.post('/api/auth/verify-otp', { phone, code });
      login(res.data.token, res.data.user); go(res.data.user);
    } catch (err) { setError(err.response?.data?.error || 'کد نامعتبر'); }
    finally { setLoading(false); }
  };

  const inp = { border: '2px solid #e5e7eb', borderRadius: 10, padding: '12px 14px', fontSize: '1rem', outline: 'none', fontFamily: 'inherit', width: '100%', boxSizing: 'border-box', marginBottom: 12 };
  const btn = { background: 'linear-gradient(135deg,#0d2137,#1a4a7a)', color: '#fff', border: 'none', borderRadius: 12, padding: '14px', fontSize: '1rem', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', width: '100%' };
  const lbl = { fontSize: '0.88rem', fontWeight: 700, color: '#374151', marginBottom: 6, display: 'block' };
  const errStyle = { background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10, padding: '10px 14px', fontSize: '0.88rem', color: '#dc2626', marginBottom: 12 };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(145deg,#0d1b2a,#1b2838,#0d2137)', fontFamily: 'Vazirmatn,Tahoma,sans-serif', padding: '1rem', direction: 'rtl' }}>
      <div style={{ background: '#fff', borderRadius: 24, padding: '2rem', width: '100%', maxWidth: 400, boxShadow: '0 25px 80px rgba(0,0,0,0.4)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: '1.5rem' }}>
          <div style={{ fontSize: '2rem', background: '#0d2137', borderRadius: 14, width: 52, height: 52, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>🔧</div>
          <div>
            <div style={{ fontWeight: 800, fontSize: '1.2rem', color: '#0d2137' }}>یاراسمارت</div>
            <div style={{ color: '#64748b', fontSize: '0.82rem' }}>سیستم مدیریت قطعات گارانتی</div>
          </div>
        </div>
        <div style={{ display: 'flex', background: '#f1f5f9', borderRadius: 12, padding: 4, marginBottom: '1.5rem', gap: 4 }}>
          {[['password', '🔑 ورود با رمز'], ['otp', '📱 ورود با پیامک']].map(([m, l]) => (
            <button key={m} onClick={() => { setMode(m); setError(''); setOtpStep(1); }} style={{ flex: 1, border: 'none', padding: '10px 6px', borderRadius: 10, cursor: 'pointer', fontFamily: 'inherit', fontSize: '0.85rem', fontWeight: 600, background: mode === m ? '#fff' : 'none', color: mode === m ? '#0d2137' : '#64748b', boxShadow: mode === m ? '0 2px 8px rgba(0,0,0,0.1)' : 'none' }}>{l}</button>
          ))}
        </div>
        {mode === 'password' && (
          <div>
            <label style={lbl}>شماره موبایل</label>
            <input style={inp} type="tel" dir="ltr" placeholder="09XXXXXXXXX" value={phone} onChange={e => setPhone(e.target.value)} maxLength={11} />
            <label style={lbl}>رمز عبور</label>
            <input style={inp} type="password" placeholder="رمز عبور" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handlePasswordLogin()} />
            {error && <div style={errStyle}>{error}</div>}
            <button style={btn} onClick={handlePasswordLogin} disabled={loading}>{loading ? 'در حال ورود...' : 'ورود'}</button>
          </div>
        )}
        {mode === 'otp' && otpStep === 1 && (
          <div>
            <label style={lbl}>شماره موبایل</label>
            <input style={inp} type="tel" dir="ltr" placeholder="09XXXXXXXXX" value={phone} onChange={e => setPhone(e.target.value)} maxLength={11} />
            {error && <div style={errStyle}>{error}</div>}
            <button style={btn} onClick={requestOTP} disabled={loading}>{loading ? 'در حال ارسال...' : 'دریافت کد تایید'}</button>
          </div>
        )}
        {mode === 'otp' && otpStep === 2 && (
          <div>
            <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '10px 14px', fontSize: '0.88rem', color: '#166534', marginBottom: 12, textAlign: 'center' }}>کد تایید به {phone} ارسال شد</div>
            <label style={lbl}>کد تایید</label>
            <input style={{ ...inp, textAlign: 'center', fontSize: '1.5rem', letterSpacing: '0.3em' }} type="number" placeholder="------" value={code} onChange={e => setCode(e.target.value)} maxLength={6} dir="ltr" autoFocus />
            {error && <div style={errStyle}>{error}</div>}
            <button style={btn} onClick={verifyOTP} disabled={loading}>{loading ? '...' : 'تایید و ورود'}</button>
            <button style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: '0.88rem', textDecoration: 'underline', fontFamily: 'inherit', textAlign: 'center', width: '100%', marginTop: 10 }} onClick={() => { setOtpStep(1); setCode(''); setError(''); }}>تغییر شماره</button>
          </div>
        )}
      </div>
    </div>
  );
}
